import { render } from "./Trackers.vue?vue&type=template&id=643fb6c2&scoped=true"
import script from "./Trackers.vue?vue&type=script&setup=true&lang=js"
export * from "./Trackers.vue?vue&type=script&setup=true&lang=js"

import "./Trackers.vue?vue&type=style&index=0&id=643fb6c2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643fb6c2"],['__file',"src/components/tools/Trackers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "643fb6c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('643fb6c2', __exports__)) {
    api.reload('643fb6c2', __exports__)
  }
  
  module.hot.accept("./Trackers.vue?vue&type=template&id=643fb6c2&scoped=true", () => {
    api.rerender('643fb6c2', render)
  })

}


export default __exports__